import http from '@/core/http'
const url = 'financeiro-saldos'

const state = {
  transmissoes: {
    results: []
  },
}

const actions = {
  getRelatorioGecomGeral: async ({ commit }, payload) => {
    const result = await http.get(url, { params: payload })
    // se for chamar relatorio nao pode jogar dados no store
    if (!payload.relPDF) { commit('LISTA_TRANSMISSOES', result.data.resultMap) }
    
    return Promise.resolve(result)
  },
  clearItens: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },
}

const mutations = {
  'LISTA_TRANSMISSOES' (state, payload) {
    state.transmissoes = payload
  },

  'LIMPAR_ITEM' (state) {
    state.transmissoes = {
      results: []
    }
  },
}

const getters = {
  transmissoes: state => state.transmissoes,
}

export default { namespaced: true, state, actions, mutations, getters }